export default "__VITE_ASSET__DLdSv$Mo__"